var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPipeLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 72,
    viewBox: "0 0 87 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 24,
    width: 87,
    height: 24
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6053 47.3621V41.4094C36.7278 41.5083 36.8418 41.6039 36.9511 41.6955C37.1874 41.8936 37.4013 42.0729 37.63 42.2267C40.053 43.8562 43.7533 43.2658 45.8155 40.9032C47.5285 38.9398 47.99 36.6197 47.5551 34.1094C46.9683 30.7492 44.7898 28.1587 41.0511 28.0329C39.3006 27.9745 37.7326 28.4104 36.556 29.824C36.5361 29.8483 36.5054 29.8635 36.4562 29.888C36.4271 29.9025 36.3915 29.9202 36.3479 29.9448V28.5243H32.4031V47.3621H36.6053ZM39.9801 39.1696C38.0501 39.1706 36.4317 37.533 36.4179 35.5647H36.4189C36.4938 33.9539 37.5915 32.0004 39.9367 31.9934C40.8824 31.9894 41.7901 32.3668 42.4562 33.041C43.1224 33.7152 43.4912 34.6297 43.4801 35.5796C43.4594 37.5736 41.9101 39.1686 39.9801 39.1696Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9521 47.3621V41.4784C60.1303 41.601 60.3004 41.7267 60.4673 41.85C60.8189 42.1098 61.1564 42.359 61.5251 42.5469C64.1835 43.8993 67.7932 42.9238 69.599 40.3762C71.1088 38.2461 71.388 35.8786 70.7466 33.4052C70.0736 30.8081 68.5826 28.8798 65.861 28.2605C63.6032 27.747 61.4688 27.9943 59.8308 29.9107C59.8253 29.9174 59.8055 29.9122 59.7724 29.9035C59.7514 29.898 59.725 29.8911 59.6936 29.885V28.5454H55.7642V47.3621H59.9521ZM63.3249 39.1791C61.3879 39.1722 59.7735 37.5368 59.7666 35.5738L59.7656 35.5729C59.8455 33.9513 60.9527 32.0121 63.2933 32.0121C64.2401 32.0078 65.1487 32.3856 65.8144 33.0605C66.4801 33.7354 66.8469 34.6505 66.832 35.5995C66.8024 37.5961 65.262 39.186 63.3249 39.1791Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.961 36.5456H86.2512C86.8522 33.5815 85.2789 29.4207 81.1046 28.2973C77.1473 27.2357 73.2608 29.4008 72.1708 33.2058C71.0535 37.104 73.1946 41.0945 77.0248 42.2179C81.0433 43.3974 84.6015 41.0611 85.8428 37.8526C85.8396 37.8494 85.8356 37.8453 85.8324 37.8412C85.8251 37.833 85.8187 37.825 85.8122 37.825C85.5085 37.8243 85.2048 37.8227 84.9011 37.821C83.9723 37.8161 83.0451 37.8111 82.1171 37.8326C81.8384 37.8431 81.5726 37.9481 81.3647 38.1294C80.4923 38.9703 79.4606 39.2176 78.2859 39.0274C76.981 38.8134 75.9688 37.7404 75.961 36.5456ZM78.6613 31.5068C80.5049 31.3746 81.9053 32.2631 82.1969 33.8031H76.0641C76.0952 32.7597 77.2377 31.6086 78.6613 31.5068Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.183755 47.3619V46.9867C0.183755 42.2907 0.177075 37.5948 0.183755 32.895C0.188527 30.467 1.80608 28.4666 4.17277 28.1057C5.21297 27.9477 6.29611 28.0791 7.43079 28.0791V28.4742C7.43079 33.0908 7.43079 37.7075 7.43079 42.3241C7.43079 45.2757 5.34848 47.3466 2.39108 47.3571C1.68202 47.3638 0.967243 47.3619 0.183755 47.3619Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84753 39.2824V24.0002C11.1918 24.0704 12.5312 23.8318 13.8304 24.3009C15.7439 24.9781 17.0449 26.8428 17.081 28.9596C17.1069 30.6636 17.0963 32.3675 17.0896 34.0714C17.0772 36.978 15.2234 39.0829 12.4642 39.2834C11.6095 39.3355 10.7491 39.2824 9.84753 39.2824Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3474 42.5291H49.3196V28.834H53.3474V42.5291Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3474 24V27.2224H49.3196V24H53.3474Z",
    fill: "#202020"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 72,
    fill: "#1B2738"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 23.3622,
    fill: "white",
    transform: "translate(0 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipeLogo);
export default __webpack_public_path__ + "static/media/pipe_logo.c2e11c6573192e3d9fa8509a7f3f61dd.svg";
export { ForwardRef as ReactComponent };